import { NEW_RELIC_ACTIONS, NEW_RELIC_EVENT_TYPES, sendCustomNREvent } from '@belong/logging/new-relic';
import { IMobileDataProductsResponse, IMobileProductsResponse } from '@belong/types/api/products';
import { PRODUCT_FAMILY } from '@belong/types/product';
import { isError } from '../../helpers';
import ProductAPI from '../../services/ProductAPI';
import { ProductAvailabilityFilter } from './types';

// Main entrypoint for loading on Server or Client. Loads products from the ProductAPI.
// Use the `filter` param to pre-filter plans by journey (availability) in the API
export async function loadMobileProducts(
  productFamily: PRODUCT_FAMILY,
  filter?: ProductAvailabilityFilter,
  resolvedUrl?: string
): Promise<IMobileProductsResponse | IMobileDataProductsResponse> {
  sendCustomNREvent(NEW_RELIC_EVENT_TYPES.INTERNAL_REQUEST, {
    action: NEW_RELIC_ACTIONS.INTERNAL_REQUEST.PRODUCT_API,
    ...(resolvedUrl ? { resolvedUrl } : {})
  });

  const result = await (productFamily === PRODUCT_FAMILY.MOBILE_PLANS
    ? ProductAPI.getMobileProducts(filter)
    : ProductAPI.getMobileDataProducts(filter));

  if (isError(result.body)) {
    throw new Error(`loadProducts() - Failed to load Mobile Products`);
  }

  return result.body;
}
